// LIFF SDK Initialization — LINE Mini App
// App: หมออร เชียงใหม่
// Compatible with both LIFF apps and LINE Mini Apps

// Static import — LIFF SDK is bundled at build time (faster than dynamic import)
import liffModule from '@line/liff';

// LIFF IDs per environment
const LIFF_IDS = {
    developing: '2009669656-283tPTGq', // Localhost
    review: '2009669656-283tPTGq',
    published: '2009669656-283tPTGq' // Firebase URL
};

// Use developing LIFF ID by default — change to 'published' for production
const LIFF_ID = LIFF_IDS.developing;

let liffInstance = null;
let userProfile = null;

export async function initLiff() {
    try {
        const liff = liffModule;
        await liff.init({ liffId: LIFF_ID });
        liffInstance = liff;

        if (!liff.isLoggedIn()) {
            // บังคับล็อกอินผ่านหน้าเว็บ LINE เสมอเพื่อเทสต์ระบบให้เหมือนโฮสต์จริง
            liff.login({ redirectUri: window.location.href });
            // รอ redirect — ใส่ timeout 10 วิ กันค้างนาน
            await new Promise((_, reject) =>
                setTimeout(() => reject(new Error('Login redirect timeout')), 10000)
            );
        }

        userProfile = await liff.getProfile();
        console.log('✅ LIFF initialized, user:', userProfile.displayName);
        
        // --- ADD FRIENDSHIP CHECK ---
        try {
            const friendship = await liff.getFriendship();
            if (!friendship.friendFlag) {
                document.body.innerHTML = `
                    <div style="text-align:center; padding: 50px 20px; font-family: 'Noto Sans Thai', sans-serif; background: #1a0a2e; color: #fff; height: 100vh; display: flex; flex-direction: column; justify-content: center; align-items: center; box-sizing: border-box;">
                        <div style="font-size: 70px; margin-bottom: 20px;">💬</div>
                        <h2 style="color:#06C755; margin-bottom: 10px;">กรุณาเพิ่มเพื่อนก่อนทำรายการ</h2>
                        <p style="color:#a89cc8; margin-bottom:30px; font-size: 14px; line-height: 1.6;">เพื่อให้แอดมินสามารถทักแชท<br/>ยืนยันคิวและแจ้งรายละเอียดได้</p>
                        <a href="https://line.me/ti/p/@vtx4482v" style="display:block; padding: 14px 24px; background: #06C755; color: white; text-decoration: none; border-radius: 12px; font-size: 16px; font-weight: bold; margin-bottom: 15px; width: 100%; max-width: 300px; box-sizing: border-box;">➕ เพิ่มเพื่อน (Add Friend)</a>
                        <button onclick="window.location.reload()" style="display:block; padding: 14px 24px; background: transparent; color: #fff; border: 1px solid #444; border-radius: 12px; font-size: 16px; cursor:pointer; width: 100%; max-width: 300px; box-sizing: border-box;">รีเฟรชเมื่อเพิ่มเพื่อนแล้ว</button>
                    </div>
                `;
                const err = new Error('FRIEND_REQUIRED');
                err.isFriendshipError = true;
                throw err;
            }
        } catch (fErr) {
            if (fErr.isFriendshipError) throw fErr;
            console.warn('Friendship check failed/not supported:', fErr);
        }

        // Make liff globally available for other tools
        window.liff = liff;

        return userProfile;
    } catch (err) {
        console.error('LIFF init error:', err);

        if (!err.isFriendshipError) {
            // แสดงหน้า Error ทันทีถ้าเกิดข้อผิดพลาดในการโหลด LIFF
            // เพื่อให้ทราบว่าต้องไปตั้งค่า Endpoint ใน LINE Developers ให้ตรงกับ localhost หรือโดเมนจริง
            document.body.innerHTML = `
                <div style="text-align:center; padding: 50px; font-family: sans-serif;">
                    <h2>⚠️ ไม่สามารถเชื่อมต่อระบบ LINE ได้</h2>
                    <p>กรุณาตรวจสอบ LIFF ID (รหัส ${LIFF_ID})</p>
                    <p style="color:red;">ข้อผิดพลาด: ${err.message}</p>
                    <button onclick="window.location.reload()" style="padding: 10px 20px; background: #06C755; color: white; border: none; border-radius: 8px; cursor:pointer;">ลองใหม่</button>
                </div>
            `;
        }
        throw err; // ให้ bootstrap() จัดการ error screen ต่อ
    }
}

export function getProfile() {
    return userProfile;
}

export function getLiff() {
    return liffInstance;
}

export function isInLiff() {
    return liffInstance ? liffInstance.isInClient() : false;
}

export function closeLiff() {
    if (liffInstance && liffInstance.isInClient()) {
        liffInstance.closeWindow();
    }
}

// Send message to user's LINE chat (requires chat_message.write scope)
export async function sendLiffMessage(messages) {
    if (!liffInstance || !liffInstance.isInClient()) {
        console.log('📨 [Demo] Would send LINE message:', messages);
        return;
    }
    try {
        await liffInstance.sendMessages(messages);
        console.log('📨 Message sent via LIFF');
    } catch (err) {
        console.error('Failed to send LIFF message:', err);
    }
}
